export class OutOfSyncError extends Error {
  constructor() {
    super('Page out of sync.')
    this.name = 'OutOfSyncError'
  }
}
